/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @returns {Array} The array filled with two-part transition words.
 */
export default [
	[ "não apenas", "como também" ], [ "não só", "bem como" ], [ "não só", "como também" ],
	[ "não só", "mas também" ], [ "ora", "ora" ], [ "ou", "ou" ], [ "quer", "quer" ],
];

